import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { IEDate } from '@appbase/util';
import { openReserveResourceDate, openReserveResourceTime } from '@reserve/popup-handler';
import * as types from '@reserve/store/types'
import * as accountTypes from '@account/store/types'
import { mapGetters } from 'vuex';
import reserveHelper from '@reserve/reserve-helper'

import DayItem from './DayItem.vue'


@Component({
    components: {
        DayItem
    },

    computed: mapGetters({   
        user: accountTypes.USER,
        curCompany: types.CALENDAR_COMPANY,
        curCategory: types.CALENDAR_CATEGORY,  
        selectedResources: types.SELECTED_RESOURCE_LIST 
    })
})
export default class DayRawItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.DateItem;

    user!: account.User;
    selectedResources!: reserve.ResourceItemBase[];
    curCompany!: string | null;
    curCategory!: 'FAVORITE' | 'EWS' | 'DB';

    eventsModel: reserve.CalendarItem[] = [];

    @Watch('item')
    itemChanged(newVal: reserve.DateItem) {
        if(newVal.events) {
            this.eventsModel = newVal.events.filter(e => e.id !== 'null');         
        }
    }

    created() {
        if(this.item != null)
            this.itemChanged(this.item);
    }

    onSelectDblClick() {   
        let resources = this.selectedResources.filter(r => !reserveHelper.isHeaderType(r.resourceType));  
        let resource = resources[0];
        let dblStartTime = IEDate(this.item.date);
        let dblEndTime = IEDate(this.item.date)
        dblEndTime.setMinutes(dblEndTime.getMinutes() + 30);

        if(resources.length > 0) {            
            openReserveResourceTime(resource.comCode, dblStartTime, dblEndTime, resource.itemStore, resource.address);
        } else {
            let comCode: string = this.curCompany == null ? this.user.comCode : this.curCompany;
            openReserveResourceDate(comCode, dblStartTime, this.curCategory);
        }                
    }
}